"use client";
import Image from "next/image";
import dynamic from "next/dynamic";
import { FC, useContext, useEffect, useMemo, useRef } from "react";

import { Section1 } from "./section1";
import { Section3 } from "./section3";
import { Section4 } from "./section4";
import { Section5 } from "./section5";
import { Section6 } from "./section6";
import { DeviceTypeContext } from "@/lib/isMobile";
/* const DynamicComponent = dynamic(() => import("../pages/MyComponent"), {
  ssr: false,
}); */

export const SiteContent: FC = () => {
  const deviceType = useContext(DeviceTypeContext);

  return (
    <main className="w-full bg-white md:min-w-[1200px]">
      <section>
        <Section1 />
      </section>
      <section>
        <div className="pt-10 md:pt-24 px-6 md:px-0">
          <h3 className="text-[#333333] text-lg md:text-[1.82rem] mb-5 md:mb-10 text-center font-medium">
            产品体系
          </h3>
          <Image
            src="/mobile/home/productsystem.png"
            className="w-full h-[224px] sm:h-[500px] block md:hidden"
            alt="productsystem"
            width="1006"
            height="671"
          />
          <Image
            src="/home/productsystem1.png"
            className="w-full h-[540px] object-cover object-center hidden md:block"
            alt="productsystem"
            width="5121"
            height="1069"
            priority
          />
        </div>
      </section>
      <section>
        <Section3 isMobile={deviceType.isMobile} />
      </section>
      <section>
        <Section4 />
      </section>
      <section>
        <Section5 isMobile={deviceType.isMobile} />
      </section>
      <section>
        <Section6 {...deviceType} />
      </section>
    </main>
  );
};
